export const DISPLAY_CONSTS = {
  CREATE_NEW_USER: $localize`create new user`,
  CREATE_NEW_LOCATION: $localize`create new location`,
  SHOWING_RESULTS: $localize`Showing %s results`,
  ADD_STOP: $localize`Add Pickup`,
  ADD_DELIVERY: $localize`Add Delivery`,
  ADD_BUTTON_TEXT: $localize`Add`,
};
